import CommLabelPrintClient from '@/comp/lib/commLabelPrintClient'

/**
 * 过滤打印数据中值为数组的字段（如 reelIdList），避免 PrintService 序列化异常
 *
 * @param {Array<Object>} generalData 打印数据列表
 * @returns {Array<Object>}
 */
function omitArrayFields (generalData) {
    return generalData.map(data => {
        const row = {}
        for (const key of Object.keys(data)) {
            if (!Array.isArray(data[key])) {
                row[key] = data[key]
            }
        }
        return row
    })
}

/**
 * 根据模板 ID 获取标签文件名
 *
 * @param {number|string} templateId 打印模板 ID
 * @returns {Promise<string|null>}
 */
function fetchTemplateFileName (templateId) {
    return new Promise(resolve => {
        if (!templateId) {
            resolve(null)
            return
        }
        window.etao.requests.get({
            url: '/etao-basic/print-template/detail',
            data: { id: templateId },
            successMessage: false,
            success: res => {
                if (res.code === 200 && res.data && res.data.templateFileName) {
                    resolve(res.data.templateFileName)
                } else {
                    resolve(null)
                }
            },
            error: () => resolve(null)
        })
    })
}

/**
 * 通过本地 PrintService HTTP 接口执行 LABEL 标签打印
 *
 * @param {Object} materialSnPrintLabelInfo 打印信息（含 templateId、generalData）
 * @returns {Promise<void>}
 */
export async function labelPrint (materialSnPrintLabelInfo) {
    const generalData = materialSnPrintLabelInfo && materialSnPrintLabelInfo.generalData
    if (!generalData || !generalData.length) {
        return
    }

    if (!materialSnPrintLabelInfo.templateId) {
        window.etao.message.toast('获取打印模板失败', 'error')
        return
    }

    const templateFileName = await fetchTemplateFileName(materialSnPrintLabelInfo.templateId)
    if (!templateFileName) {
        window.etao.message.toast('标签文件名称未配置', 'error')
        return
    }

    const listPrintValue = omitArrayFields(generalData)

    const client = new CommLabelPrintClient()
    try {
        const reelId = generalData[0].reelId
        await client.printLabel({
            PrintJobName: String(reelId != null ? reelId : ''),
            Copies: '1',
            TemplateName: templateFileName,
            ListPrintValue: listPrintValue
        })
    } catch (e) {
        window.etao.message.toast('Print Service Not Running', 'error')
        throw e
    }
}



// WEBPACK FOOTER //
// ./src/const/labelPrint.js